import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33d6f7eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container content compare" }
const _hoisted_2 = { class: "compare__title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "items-in-line flex-start"
}
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 0,
  class: "compare__title-actions"
}
const _hoisted_7 = {
  key: 1,
  class: "compare__title-actions"
}
const _hoisted_8 = {
  key: 0,
  class: "container center"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 2,
  class: "items-in-column align-center"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Добавьте объявления, чтобы сравнить", -1))
const _hoisted_12 = { class: "items-in-column" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Объявление удалено", -1))

import { computed, onMounted, ref, Ref, watch } from 'vue';
import { CompareType, ResultCardType } from '@/types';
import { ChangeCompareTitleModal, CompareTable } from '@/components';
import { useRoute, useRouter } from 'vue-router';
import { useCompareStore } from '@/store/modules/compare';
import { useUserStore } from '@/store/modules/user';
import { useAppStore } from '@/store/modules/app';


export default /*#__PURE__*/_defineComponent({
  __name: 'Compare',
  setup(__props) {

const router = useRouter();
const offerCardsForComparison: Ref<ResultCardType[]> = ref([]);
const showChangeTitleModal = ref(false);
const isLoading = ref(false);
const isNewCompare = ref(false);
const compareData: Ref<CompareType | undefined> = ref(undefined);
const successMessage: Ref<string | undefined> = ref(undefined);

const deleteCardDataModal: Ref<{
  show: boolean;
  card: ResultCardType | undefined;
}> = ref({
  show: false,
  card: undefined,
});
const changeIsCompare = async (card: ResultCardType) => {
  await useCompareStore().changeIsCompare(card);
};

const openAuthModal = () => {
  useAppStore().openAuthModal(true);
};
const saveNewCompare = (data: { message: string }) => {
  successMessage.value = data.message;
  compareData.value = useCompareStore().compareData;
};

const returnCard = async (card: ResultCardType) => {
  await changeIsCompare(card);
  await closeInfoModal();
  offerCardsForComparison.value = useCompareStore().compareList;
};
const deleteCard = async (card: ResultCardType) => {
  if (isNewCompare.value) {
    changeIsCompare(card);
    deleteCardDataModal.value = {
      show: true,
      card: card,
    };
  } else {
    if (compareData.value) {
      if (offerCardsForComparison.value.length > 1) {
        deleteCardDataModal.value = {
          show: true,
          card: card,
        };
        await useCompareStore()
          .deleteHouseFromCompare(compareData.value.id, card.id)
          .then(() => {
            const compareIndex = offerCardsForComparison.value.findIndex(
              el => el.id === card.id,
            );

            if (compareIndex >= 0) {
              offerCardsForComparison.value?.splice(compareIndex, 1);
            }
          });
      } else {
        await useCompareStore()
          .deleteCompare(compareData.value.id)
          .then(() => {
            createNewCompare();
          });
      }
    }
  }
};

const closeInfoModal = async () => {
  deleteCardDataModal.value = {
    show: false,
    card: undefined,
  };
};

const createNewCompare = () => {
  offerCardsForComparison.value = [];
  isNewCompare.value = true;
  compareData.value = undefined;
  useCompareStore().changeCurrentCompare(undefined, []);
  useCompareStore().changeCompareList([]);
  router.push({ query: undefined });
};

const route = useRoute();
const comparisonId = computed(() => {
  return route.query.id;
});

const getCompare = async () => {
  if (comparisonId.value) {
    isLoading.value = true;
    try {
      const res = await useCompareStore().getComparisonById(+comparisonId.value);

      if (res) {
        offerCardsForComparison.value = res.found.map(el => {
          return { ...el };
        });
        useCompareStore().changeCompareList(res.found);
        compareData.value = useCompareStore().compareData;
      }
    } finally {
      isLoading.value = false;
    }
  }
};

onMounted(async () => {
  if (comparisonId.value) {
    await getCompare();
  } else if (useCompareStore().compareData) {
    compareData.value = useCompareStore().compareData;
    offerCardsForComparison.value = useCompareStore().compareList;
    await router.push({ query: { id: String(compareData.value?.id) } });
  } else {
    offerCardsForComparison.value = useCompareStore().compareList;
    isNewCompare.value = true;
  }
});

watch(
  () => comparisonId.value,
  () => {
    if (comparisonId.value) {
      getCompare();
      isNewCompare.value = false;
    }
  },
);

watch(
  () => useCompareStore().compareData,
  async () => {
    await router.push({ query: { id: String(useCompareStore().compareData?.id) } });
  },
);

return (_ctx: any,_cache: any) => {
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_base_info_modal = _resolveComponent("base-info-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (isNewCompare.value)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_3, "Сравнение объявлений"))
        : (compareData.value)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_4, [
              _createTextVNode(" Сравнение объявлений: " + _toDisplayString(compareData.value.name) + " ", 1),
              _createVNode(_component_base_icon, {
                clickable: "",
                "font-size": "28",
                name: "edit",
                onClick: _cache[0] || (_cache[0] = 
            () => {
              showChangeTitleModal.value = true;
            }
          )
              })
            ]))
          : _createCommentVNode("", true),
      (!isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_unref(useUserStore)().user)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (compareData.value)
                    ? (_openBlock(), _createBlock(_component_base_button, {
                        key: 0,
                        href: { name: 'main' },
                        height: "auto",
                        "style-type": "coloredBorder",
                        text: "Добавить объявления"
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_base_button, {
                    href: { name: 'profile', params: { id: 'compare' } },
                    height: "auto",
                    "style-type": "coloredBorder",
                    text: "Список сравнений"
                  }),
                  (compareData.value)
                    ? (_openBlock(), _createBlock(_component_base_button, {
                        key: 1,
                        text: 
              _unref(useAppStore)().getWindowWidth() > 600
                ? 'Создать новый список'
                : 'Новый список'
            ,
                        height: "auto",
                        "style-type": "coloredBorder",
                        onClick: createNewCompare
                      }, null, 8, ["text"]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_base_button, {
                    "style-type": "coloredBorder",
                    text: "Сохранить",
                    onClick: openAuthModal
                  })
                ]))
          ]))
        : _createCommentVNode("", true)
    ]),
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_base_spinner, {
            size: 50,
            color: "#009D3E"
          })
        ]))
      : (offerCardsForComparison.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_unref(CompareTable), {
              offerCards: offerCardsForComparison.value,
              onChangeIsCompare: _cache[1] || (_cache[1] = ($event: any) => (deleteCard($event))),
              onChangeIsFavorite: _cache[2] || (_cache[2] = ($event: any) => (_unref(useUserStore)().changeIsFavorite($event)))
            }, null, 8, ["offerCards"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_base_button, {
              href: { name: 'main' },
              height: "40",
              text: "К объявлениям"
            })
          ])),
    (_openBlock(), _createBlock(_component_base_info_modal, {
      key: deleteCardDataModal.value.card?.id,
      "show-info-modal": deleteCardDataModal.value.show,
      position: "top-right",
      onClose: _cache[4] || (_cache[4] = ($event: any) => (closeInfoModal()))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          (deleteCardDataModal.value.card !== undefined)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "underline white-color",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (returnCard(deleteCardDataModal.value.card)))
              }, " Вернуть к сравнению "))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["show-info-modal"])),
    (compareData.value)
      ? (_openBlock(), _createBlock(_unref(ChangeCompareTitleModal), {
          key: 3,
          "compare-id": compareData.value?.id,
          "compare-name": compareData.value?.name,
          "show-modal": showChangeTitleModal.value,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (showChangeTitleModal.value = false)),
          onUpdateSuccessMessage: saveNewCompare
        }, null, 8, ["compare-id", "compare-name", "show-modal"]))
      : _createCommentVNode("", true),
    (!!successMessage.value)
      ? (_openBlock(), _createBlock(_component_base_info_modal, {
          key: 4,
          "show-info-modal": !!successMessage.value,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (successMessage.value = undefined))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(successMessage.value), 1)
          ]),
          _: 1
        }, 8, ["show-info-modal"]))
      : _createCommentVNode("", true)
  ]))
}
}

})